import React, { lazy } from "react";
import { Navigate } from "react-router-dom";
import UserValidator from "./validators/UserValidator";
import ContinueAfterFinishAnswer from "../Modules/session/ContinueAfterFinishAnswer";
const StartPage = lazy(() => import("../Modules/session/StartPage"));
const DiscussInvitePage = lazy(() =>
  import("../Modules/session/DiscussInvite")
);
const UserWaiting = lazy(() => import("../Modules/session/UserWaiting"));
const ContinueQuestion = lazy(() =>
  import("../Modules/session/ContinueQuestion")
);
const UserAsk = lazy(() => import("../Modules/session/UserAsk"));
const TellUser = lazy(() => import("../Modules/session/TellUser"));
const Listen = lazy(() => import("../Modules/session/Listen"));
const Emotions = lazy(() => import("../Modules/session/Emotions"));
const StartAfterStop = lazy(() => import("../Modules/session/StartAfterStop"));
const InformalStop = lazy(() => import("../Modules/session/InformalStop"));
const ReturnAfterStop = lazy(() =>
  import("../Modules/session/ReturnAfterStop")
);
const SaySomething = lazy(() => import("../Modules/session/SaySomething"));
const SummarizedAsk = lazy(() => import("../Modules/session/SummarizedAsk"));
const SummarizedSaid = lazy(() => import("../Modules/session/SummarizedSaid"));
const SummarizedQuestionAsk = lazy(() =>
  import("../Modules/session/SummarizedQuestionAsk")
);
const SummarizedWhatSaid = lazy(() =>
  import("../Modules/session/SummarizedWhatSaid")
);
const Summarized = lazy(() => import("../Modules/session/Summarized"));
const SummarizedQuestionFinish = lazy(() =>
  import("../Modules/session/SummarizedQuestionFinish")
);
const GenerateLinkPage = lazy(() => import("../Modules/session/GenerateLink"));
const AnswerQuestionPage = lazy(() =>
  import("../Modules/session/AnswerQuestion")
);
const ListenAnswerPage = lazy(() => import("../Modules/session/ListenAnswer"));
const Waiting = lazy(() => import("../Modules/session/Waiting"));
const ContinueAfterFinish = lazy(() =>
  import("../Modules/session/ContinueAfterFinish")
);
const AnswerSummarizeListen = lazy(() =>
  import("../Modules/session/AnswerSummarizeListen")
);
const AnswerSummarizeSaid = lazy(() =>
  import("../Modules/session/AnswerSummarizeSaid")
);
const SummarizedAnswer = lazy(() =>
  import("../Modules/session/SummarizedAnswer")
);

export const Users = [
  {
    path: `${process.env.REACT_APP_FRONT_URL}`,
    element: <UserValidator />,
    children: [
      {
        path: "",
        element: <StartPage />,
      },
      {
        path: "generate-link",
        element: <GenerateLinkPage />,
      },
      {
        path: `discuss-invite/:id`,
        element: <DiscussInvitePage />,
      },
      {
        path: "return-afterstop",
        element: <ReturnAfterStop />,
      },
      {
        path: "user-waiting",
        element: <UserWaiting />,
      },
      {
        path: "continue",
        element: <ContinueQuestion />,
      },
      {
        path: "user-ask",
        element: <UserAsk />,
      },
      {
        path: "tell-user",
        element: <TellUser />,
      },
      {
        path: "listen",
        element: <Listen />,
      },
      {
        path: "emotions",
        element: <Emotions />,
      },
      {
        path: "start-afterstop",
        element: <StartAfterStop />,
      },
      {
        path: "informal-stop",
        element: <InformalStop />,
      },
      {
        path: "say-something",
        element: <SaySomething />,
      },
      // for question
      {
        path: "summarizedQuestionFinish",
        element: <SummarizedQuestionFinish />,
      },
      //  for answer
      {
        path: "summarized-answer",
        element: <SummarizedAnswer />,
      },
      // for statement
      {
        path: "summarized",
        element: <Summarized />,
      },
      {
        path: "summarized-ask",
        element: <SummarizedAsk />,
      },
      {
        path: "summarized-said",
        element: <SummarizedSaid />,
      },
      {
        path: "summarized-questionask",
        element: <SummarizedQuestionAsk />,
      },
      {
        path: "summarized-whatsaid",
        element: <SummarizedWhatSaid />,
      },
      {
        path: "answer-question",
        element: <AnswerQuestionPage />,
      },
      {
        path: "listen-answer",
        element: <ListenAnswerPage />,
      },
      {
        path: "wait-to-continue",
        element: <Waiting />,
      },
      {
        path: "please-wait",
        element: <ContinueAfterFinish />,
      },
      {
        path: "please-wait-answer",
        element: <ContinueAfterFinishAnswer />,
      },
      {
        path: "answer-summarize-listen",
        element: <AnswerSummarizeListen />,
      },
      {
        path: "answer-summarize-said",
        element: <AnswerSummarizeSaid />,
      },
    ],
  },
  {
    path: "/*",
    element: <Navigate to={`${process.env.REACT_APP_FRONT_URL}`} />,
  },
];

export default Users;
